import useReveal from "../../hooks/useReveal";

import "./stats.scss";

export default function Stats() {
  const [figRef, , figCls] = useReveal({ threshold: 0.3 });
  return (
    <section className="numbers" id="numbers">
      <div className={`figures ${figCls}`} ref={figRef}>
        <div className="figure figure-lg">
          <span className="figure-value">124,000,000</span>
          <span className="figure-label">monthly players</span>
        </div>
        <div className="figure figure-sm">
          <span className="figure-value">~500,000</span>
          <span className="figure-label">online at once</span>
        </div>
      </div>
    </section>
  );
}
